import { DocumentFile, DocumentFileType, DocumentRecord } from '../../models/Document'

export const ALL_UPLOADERS_FILTER_ID = 'all'

export const isEmailAttachmentDocument = (document: DocumentRecord): boolean => document.files[0]?.type === DocumentFileType.EMAIL_ATTACHMENT

export const getDocumentFile = (document: DocumentRecord | null): DocumentFile | undefined => document?.files.at(0)

export const isSameDocumentFile = (a?: DocumentFile, b?: DocumentFile): boolean => {
  if (!a || !b) {
    return a === b
  }
  if (a.type === DocumentFileType.INTEGRATION && b.type === DocumentFileType.INTEGRATION) {
    return a.connector === b.connector && a.fileId === b.fileId
  }
  if (a.type === DocumentFileType.EMAIL_ATTACHMENT && b.type === DocumentFileType.EMAIL_ATTACHMENT) {
    return a.connector === b.connector && a.emailId === b.emailId && a.attachmentId === b.attachmentId
  }
  if (a.type === DocumentFileType.ZOCKS && b.type === DocumentFileType.ZOCKS) {
    return a.fileId === b.fileId
  }
  return false
}
